import type { OfferLocaleOverrides } from '../base';

export const AZOverrides: OfferLocaleOverrides = {
  locale: 'AZ',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText:
                'Copy legal description from the tax record. Be sure lot and block is only included in the lot and block fields above and does not repeat in this field.',
            },
          },
        },
        emdCard: {
          fields: {
            numbersDaysEmdDue: null,
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellersAgentCard: {
          disallowRemoveForIndex: [0],
        },
      },
    },
    additionalContacts: {
      cards: {
        homeWarrantyContactCard: {
          hideByDefault: false,
          order: 1,
        },
        addAdditionalContactCard: {
          outerTitle: 'Add additional contacts (Appraiser, Attorney, etc)',
          fields: {
            newContact: {
              options: (options) =>
                options.filter(
                  ({ value }) => value !== 'additionalContacts.homeWarranty',
                ),
            },
          },
        },
      },
    },
  },
};
